import { Text } from "@fluentui/react-northstar";
import styled from "styled-components";

export const Title = styled(Text)`
    color: var(--Light-theme-Rest-Foreground-Default-Foreground-3, #fff);

    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
`;
